import React, {useEffect, useState} from 'react';
import {Button, Col,Form,message,Row,Select,Image,Upload,Modal   } from "antd";
import { EditOutlined,ExclamationCircleFilled } from '@ant-design/icons';
import './index.css'
import {useDispatch, useSelector,} from 'react-redux';
import {getUserPerms, updateAvatar} from '../../api/user'
import {setUserInfo} from "../../store/modules/user";
import SettingUsernameApp from "./settingUsername";
import SettingPwdApp from "./settingPwd";
import SettingPhoneApp from "./settingPhone";
import SettingEmailApp from "./settingEmail";
import WalletInfoApp from './walletInfo';
const { confirm } = Modal;

//设置
const InfoSettingApp =(props)=>{
    //父组件传输
    const {handleCancelModel,setHomePageIndex,homePageIndex} = props
    const [modeIndex,setModeIndex] = useState(0)
    const dispatch = useDispatch()
    const {userInfo} = useSelector(state=>state.user)


    // const {avatar,email,phone,username}=userInfo
    const [avatar,setAvatar] = useState(userInfo.avatar)
    const [email,setEmail] = useState(userInfo.email)
    const [phone,setPhone] = useState(userInfo.phone)
    const [username,setUsername] = useState(userInfo.username)
    const [isSettingUsernameOpen,setIsSettingUsernameOpen] = useState(false)
    const [isSettingPwdOpen,setIsSettingPwdOpen] = useState(false)
    const [isSettingPhoneOpen,setIsSettingPhoneOpen] = useState(false)
    const [isSettingEmailOpen,setIsSettingEmailOpen] = useState(false)
    //关闭弹窗
    const handleCloseModel = ()=>{
        setIsSettingUsernameOpen(false)
        setIsSettingPwdOpen(false)
        setIsSettingPhoneOpen(false)
        setIsSettingEmailOpen(false)
    }
    const handleSettingEmailOpen = ()=>{
        setIsSettingEmailOpen(true)
    }
    const handleSettingUsernameOpen = ()=>{
        setIsSettingUsernameOpen(true)
    }
    const handleSettingPwdOpen = ()=>{
        setIsSettingPwdOpen(true)
    }
    const handleSettingPhoneOpen = ()=>{
        setIsSettingPhoneOpen(true)
    }
    //重新获取用户信息
    const handleOk = ()=>{
        getUserPerms().then(userInfoRes=>{
            if(userInfoRes.code === 200){
                message.success('修改成功');
                dispatch(setUserInfo(userInfoRes.data))
                setAvatar(userInfoRes.data.avatar)
                setEmail(userInfoRes.data.email)
                setPhone(userInfoRes.data.phone)
                setUsername(userInfoRes.data.username)
                handleCloseModel()
            }
        })
    }
    //登出
    const handleLogout = ()=>{
        confirm({
            title: '提示',
            icon: <ExclamationCircleFilled />,
            content: '确定要登出吗?',
            okText:'确定',
            cancelText:'取消',
            onOk() {
                localStorage.clear()
                setTimeout(()=>{
                    window.location.reload()
                },200)
            }
        });
    }
    //更新头像
    const propsUpload = {
        beforeUpload: async(file) => {
            await updateAvatar({file}).then(res=>{
                if(res.code == 200){
                    setAvatar(null)
                    message.success('更新成功');
                    handleOk()
                }else{
                    message.success('更新失败');
                }
            })
            return Upload.LIST_IGNORE;
        }
    };
    return (
        <div className="InfoSettingApp">
            <div className='mode'>
                <span onClick={()=>setModeIndex(0)} className={modeIndex===1?'c':''}>账号设置</span>
                <font onClick={()=>setModeIndex(1)} className={modeIndex===0?'c':''}>我的钱包</font>
            </div>
            {
                modeIndex===0?
                    <div>
                        <div className={'textCenter headCon'}>
                            <Image src={avatar} width={100} className={'headImage'} preview={false}></Image>
                        </div>
                        <div className={'textCenter setTitle'} >
                            <Upload {...propsUpload}>
                                修改头像
                            </Upload>
                        </div>
                        <Row className={'info'}>
                            <Col span={6}>用户名：</Col>
                            <Col span={16}>{username}</Col>
                            <Col span={2} className={'hover'} onClick={handleSettingUsernameOpen}><EditOutlined style={{ fontSize: '18px'}}/></Col>
                        </Row>
                        <Row className={'info'}>
                            <Col span={6}>手机号：</Col>
                            <Col span={16}>{phone}</Col>
                            <Col span={2} className={'hover'} onClick={handleSettingPhoneOpen}><EditOutlined style={{ fontSize: '18px'}}/></Col>
                        </Row>
                        <Row className={'info'}>
                            <Col span={6}>邮<span style={{visibility:'hidden'}}>邮</span>箱：</Col>
                            <Col span={16}>{email}</Col>
                            <Col span={2} className={'hover'} onClick={handleSettingEmailOpen}><EditOutlined style={{ fontSize: '18px'}}/></Col>
                        </Row>
                        <div className={'infoLast'}>
                            <span onClick={handleSettingPwdOpen}>修改密码</span>
                            <div style={{ display: 'inline-block', width: '152px' }}> </div>
                            <span onClick={handleLogout}>注销登录</span>
                        </div>
                        <div className='textRight'>
                            <Button className='selfBtn btn2' onClick={handleCancelModel}>
                                关 闭
                            </Button>
                        </div>
                    </div>
                    :
                    <div>
                        <WalletInfoApp homePageIndex={homePageIndex} setHomePageIndex={setHomePageIndex} handleCancelModel={handleCancelModel}/>
                    </div>
            }
            <Modal footer={null} destroyOnClose={true} title="更新用户名" open={isSettingUsernameOpen} onCancel={handleCloseModel} width={360}>
                <SettingUsernameApp handleOk={handleOk} handleCloseModel={handleCloseModel} />
            </Modal>
            <Modal footer={null} destroyOnClose={true} title="修改密码" open={isSettingPwdOpen} onCancel={handleCloseModel} width={360}>
                <SettingPwdApp handleOk={handleOk} handleCloseModel={handleCloseModel} />
            </Modal>
            <Modal footer={null} destroyOnClose={true} title="更新手机号" open={isSettingPhoneOpen} onCancel={handleCloseModel} width={360}>
                <SettingPhoneApp handleOk={handleOk} handleCloseModel={handleCloseModel} />
            </Modal>
            <Modal footer={null} destroyOnClose={true} title="更新邮箱" open={isSettingEmailOpen} onCancel={handleCloseModel} width={360}>
                <SettingEmailApp handleOk={handleOk} handleCloseModel={handleCloseModel} />
            </Modal>
        </div>

    )
}

export default InfoSettingApp
